import React from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import {
  CircularProgress,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { COVENANTS_DATE_TIME_FORMAT } from '~/modules/covenants/constants.tsx';
import { managerStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/styles.ts';
import {
  BLACK_LIST_DELETE_DISABLED_TOOLTIP,
  BLACK_LIST_DELETE_TOOLTIP,
} from '~/modules/covenants/CovenantsEmailBlackList/constants.ts';
import { blackListStyles } from '~/modules/covenants/CovenantsEmailBlackList/styles.ts';
import type { TBlockedEmailRowProps } from '~/modules/covenants/CovenantsEmailBlackList/types.ts';
import { formatDate } from '~/modules/covenants/utils.ts';

const BlockedEmailRow: React.FC<TBlockedEmailRowProps> = ({
  block,
  deletingEmail,
  onDeleteEmail,
}) => {
  const isDeletingCurrentRow = deletingEmail === block.email;
  const isDeleteDisabled = isDeletingCurrentRow || !onDeleteEmail;
  const deleteTooltipTitle = onDeleteEmail
    ? BLACK_LIST_DELETE_TOOLTIP
    : BLACK_LIST_DELETE_DISABLED_TOOLTIP;

  const handleDeleteClick = () => {
    if (isDeleteDisabled) {
      return;
    }

    void onDeleteEmail?.(block.email);
  };

  const renderDeleteAction = () =>
    isDeletingCurrentRow ? <CircularProgress size={18} /> : <DeleteOutlineIcon fontSize="small" />;

  return (
    <TableRow hover sx={managerStyles.tableRow}>
      <TableCell sx={managerStyles.tableBodyCell}>
        <Typography variant="body2" sx={blackListStyles.emailText}>
          {block.email}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={managerStyles.tableBodyCell}>
        <Typography variant="body2" sx={blackListStyles.dateText}>
          {block.createdAt ? formatDate(block.createdAt, COVENANTS_DATE_TIME_FORMAT) : '-'}
        </Typography>
      </TableCell>
      <TableCell align="right" sx={managerStyles.tableBodyCell}>
        <Tooltip title={deleteTooltipTitle}>
          <IconButton
            color="default"
            aria-disabled={isDeleteDisabled}
            tabIndex={isDeleteDisabled ? -1 : 0}
            onClick={handleDeleteClick}
            sx={[
              blackListStyles.deleteButton,
              isDeleteDisabled && blackListStyles.deleteButtonDisabled,
            ]}
          >
            {renderDeleteAction()}
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default BlockedEmailRow;
